// extracted by mini-css-extract-plugin
export default {"page":"I0-z","cartModal":"J0-z","checkout":"K0-z","placeholder":"L0-z","account":"M0-z"};